module.exports = __webpack_public_path__ + "img/347.04043508.png";